export default __webpack_public_path__ + "static/media/fundraiseWithdraw.44cfeb85.png";